import { defineStore } from "pinia";
import { debounce } from "lodash-es";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    role: null,
    loading: false,
    lastFetched: null, // Cache timestamp
  }),
  actions: {
    async fetchUser() {
      const now = Date.now();
      // Avoid redundant API calls within 5 minutes
      if (this.user && this.role && this.lastFetched && now - this.lastFetched < 300000) {
        console.log("Using cached user data:", this.user);
        return true;
      }
      this.loading = true;
      try {
        const res = await fetch("/api/user", { credentials: "include" });
        if (!res.ok) throw new Error("Not authenticated");
        const data = await res.json();
        this.user = data;
        this.role = data.role;
        this.lastFetched = now; // Update cache timestamp
        return true;
      } catch (err) {
        console.error("Auth fetch failed:", err);
        this.user = null;
        this.role = null;
        this.lastFetched = null;
        return false;
      } finally {
        this.loading = false;
      }
    },
    fetchUserDebounced: debounce(async function () {
      return await this.fetchUser();
    }, 300), // Debounce fetchUser to prevent excessive calls
    logout() {
      this.user = null;
      this.role = null;
      this.lastFetched = null; // Clear cache timestamp on logout
    }
  }
});